import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "about-page" }
const _hoisted_2 = { class: "top-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "about-main" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

import { baseUrl } from '@/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(baseUrl) + '/banner3.png',
        alt: "Banner",
        class: "banner-image"
      }, null, 8, _hoisted_3),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "banner-info" }, [
        _createElementVNode("div", { class: "label" }, "六年沉淀"),
        _createElementVNode("div", { class: "label" }, "让器械合规与创新同行")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        src: _unref(baseUrl) + '/about1.png',
        alt: "Banner",
        class: "about-image"
      }, null, 8, _hoisted_5),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "sub-title clear" }, "发展历程", -1)),
      _createElementVNode("img", {
        src: _unref(baseUrl) + '/about3.png',
        alt: "Banner",
        class: "about-image"
      }, null, 8, _hoisted_6),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "sub-title" }, "服务优势", -1)),
      _createElementVNode("img", {
        src: _unref(baseUrl) + '/about2.png',
        alt: "Banner",
        class: "about-image"
      }, null, 8, _hoisted_7)
    ])
  ]))
}
}

})